import React, { useState, useEffect } from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { signOutCurrentUser } from "../../api/UserAPI";

const UserSessionExpiredDialog = ({ openDialog }) => {
  const [open, setOpen] = useState(openDialog);

  const handleClose = () => {
    setOpen(false);
    signOutCurrentUser();
  };

  useEffect(() => {
    setOpen(openDialog);
  }, [openDialog]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"User Session Expired"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Your user session has expired. Please log back in to the site to
          continue.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserSessionExpiredDialog;
